import { getContext, settled } from '@ember/test-helpers';

import type Media from '../services/media.ts';
import type { TestContext } from '@ember/test-helpers';

export async function setBreakpoint(breakpoint: string) {
  const { owner } = getContext() as TestContext;
  const media = owner.lookup('service:media') as Media;

  if (breakpoint === 'auto') {
    media.mocked = false;
    return;
  }

  if (Object.keys(media.breakpoints).indexOf(breakpoint) === -1) {
    throw new Error(`Breakpoint "${breakpoint}" not defined as a breakpoint`);
  }

  media.mocked = true;
  media._mockedBreakpoint = breakpoint;
  media.trigger('change');

  await settled();
}
